import React, { Component } from 'react';
import { ButtonGroup, Button } from 'react-bootstrap';

interface VasInspectionsProps {

    toggleSelections: Function
    waitingReview: boolean,
    isChrome: boolean
}

class VasInspections extends Component<VasInspectionsProps> {

    render() {
        return (
            <div className="VasInspections">
                <ButtonGroup>
                    <div id="vas-inspections-btn-left">
                        {!this.props.waitingReview &&
                            <Button onClick={() => this.props.toggleSelections(["HasUnreviewedInspections-t", "HasApproved-f", "Rejected-f"])} tabIndex={-1}>
                                <div id="vas-inspections-maintenance-btn-content-wrapper">
                                    {this.props.isChrome && <input id="fleet-chrome-radio" type="checkbox" tabIndex={-1} onClick={() => this.props.toggleSelections(["HasUnreviewedInspections-t", "HasApproved-f", "Rejected-f"])}></input>}
                                    {!this.props.isChrome && <input id="fleet-fox-radio" type="checkbox" tabIndex={-1} onClick={() => this.props.toggleSelections(["HasUnreviewedInspections-t", "HasApproved-f", "Rejected-f"])}></input>}
                                    <span className="material-icons">priority_high</span>
                                    <p>Waiting Inspection Review</p>
                                </div>
                            </Button>}
                        {this.props.waitingReview && <Button id="vas-ranges-checked" onClick={() => this.props.toggleSelections(["HasUnreviewedInspections-f", "HasApproved-f", "Rejected-f"])} tabIndex={-1}>
                            <div id="vas-inspections-maintenance-btn-content-wrapper">
                                {this.props.isChrome && <input id="fleet-chrome-radio" type="checkbox" tabIndex={-1} defaultChecked onClick={() => this.props.toggleSelections(["HasUnreviewedInspections-f", "HasApproved-f", "Rejected-f"])}></input>}
                                {!this.props.isChrome && <input id="fleet-fox-radio" type="checkbox" tabIndex={-1} defaultChecked onClick={() => this.props.toggleSelections(["HasUnreviewedInspections-f", "HasApproved-f", "Rejected-f"])}></input>}
                                <span className="material-icons">priority_high</span>
                                <p>Waiting Inspection Review</p>
                            </div>
                        </Button>}
                    </div>
                </ButtonGroup>
            </div>
        )
    }
}

export default VasInspections